// extracted by mini-css-extract-plugin
export default {"inputStyle":"inputLabel_inputStyle__yrh1W"};